// Controla os campos das informações
(function () {
  'use strict';

  // Variáveis
  const $campoDescrServicoWrp = $('.descricao_servico_wrp');
  const $campoDescrServico = $('#bl_description');

  // Exibe o campo de descrição
  function handleDescriptionService() {
    if ($('input[name="settings[type]"]:checked').val() == 'nfse') {
      $campoDescrServicoWrp.show();
      $campoDescrServico.prop('disabled', false);
      $campoDescrServico.prop('required', true);
    } else {
      $campoDescrServicoWrp.hide();
      $campoDescrServico.prop('disabled', true);
      $campoDescrServico.prop('required', false);
    }
  }

  $('input[name="settings[type]"]').on('change', handleDescriptionService);
  handleDescriptionService();
})();

// Pagar.me (Modal conf)
(function () {
  'use strict';
  if ($('#modal-pagarme').length > 0) {
    const $versaoApi = $('.pm_version');
    handleApiPagarme();
    $versaoApi.on('change', handleApiPagarme);
    function handleApiPagarme() {
      const versao = $('.pm_version:checked').val();
      if (versao == 'v5') {
        $('label[for="pm_chave"]').text('Chave secreta');
        $('label[for="pm_chave2"]').text('Chave pública');
      } else if (versao == 'v4') {
        $('label[for="pm_chave"]').text('Chave secreta');
        $('label[for="pm_chave2"]').text('Chave pública');
      }
    }
  }
})();

// Dsers
(function () {
  'use strict';

  const $dsersLink = $('.dsers-link');
  if ($dsersLink.length > 0) {
    const urlApi = $dsersLink.data('link');
    $dsersLink.on('click', function (ev) {
      $.get(urlApi, function (data) {
        try {
          data = JSON.parse(data);
          window.open(data.link);
        } catch (e) {
          console.log(e);
        }
        // window.open(data);
      });
    });
  }
})();

// Memberkit
(function () {
  'use strict';
  if ('#form-memberkit'.length > 0) {
    // Variáveis
    let assocList = [];

    if ($('#form-memberkit').length > 0) {
      if (getUrlParam('mk-cfg') == 1) {
        $('#modal-memberkit').modal('show');
      }
    }

    // Exibe modal para associação
    $('.mk-add-assoc').on('click', function (ev) {
      ev.preventDefault();
      newAssoc();
    });
    function newAssoc() {
      showLoader();
      const urlApi = $('#form-memberkit').attr('action') + '?mk-infos=1';
      $.getJSON(urlApi, function (resp) {
        //console.log(resp);
        hideLoader();
        if (resp.status === 'success') {
          $('#modal-memberkit').modal('hide');
          $('#mkassoc_prod').html('');
          $('#mkassoc_prod').append(`<option></option>`);
          for (let i = 0; i < resp.products.length; i++) {
            if (!verifyAssoc(resp.products[i].id)) {
              const itemOpt = new Option(resp.products[i].title, resp.products[i].id, true, true);
              itemOpt.image = resp.products[i].image_main_small;
              $('#mkassoc_prod').append(itemOpt);
            }
          }
          $('#mkassoc_turma').html('');
          $('#mkassoc_turma').append(`<option value="" hidden>Selecione</option>`);
          for (let y = 0; y < resp.classrooms.length; y++) {
            $('#mkassoc_turma').append(
              `<option value="${resp.classrooms[y].id}|${resp.classrooms[y].title}">${resp.classrooms[y].title}</option>`,
            );
          }
          initSelect2Ajax();
          $('#modal-memberkit-assoc').modal('show');
        } else {
          console.log(resp);
          Toast.fire({
            type: 'error',
            title: resp.message,
          });
        }
      }).fail(function (resp) {
        console.log(resp);
        hideLoader();
        Toast.fire({
          type: 'error',
          title: 'Não foi possível realizar esta operação.',
        });
      });
    }

    // Ao fechar o modal de associação, exibe o modal principal
    $('#modal-memberkit-assoc').on('hidden.bs.modal', function () {
      $('#modal-memberkit').modal('show');
    });

    // Ao abrir o modal principal
    $('#modal-memberkit').on('show.bs.modal', function () {
      populateList();
    });

    // Cadastra uma nova associação
    $('#form-memberkit-assoc').on('submit', function (ev) {
      ev.preventDefault();
      const prodArr = $('#mkassoc_prod').val().split('|');
      const classArr = $('#mkassoc_turma').val().split('|');
      const assocObj = {
        product_id: prodArr[0],
        product_title: prodArr[1],
        classroom_id: classArr[0],
        classroom_title: classArr[1],
        lifetime: $('#mkassoc_lifetime').is(':checked') ? 1 : 0,
        expire_days: $('#mkassoc_expire_days').val() || 0,
      };
      assocList.push(assocObj);
      $('#assoc_list').val(JSON.stringify(assocList));
      $('#modal-memberkit-assoc').modal('hide');
      Toast.fire({
        type: 'success',
        title: 'Associação criada com sucesso!',
      });
    });

    // Verifica se já existe uma associação para um produto
    function verifyAssoc(prodId) {
      if (!assocList) {
        return false;
      }
      return assocList.some((item) => item.product_id == prodId);
    }

    // Popula lista de associações
    function populateList() {
      assocList = $('#assoc_list').val() && $('#assoc_list').val() != 'null' ? JSON.parse($('#assoc_list').val()) : [];
      $('.assoc-list-wrp').hide();
      $('#assoc-list').html('');
      if (assocList && assocList.length > 0) {
        assocList.forEach((assoc, ix) => {
          let acessoInfo = 'Vitalício';
          if (assoc.lifetime != 1) {
            acessoInfo = 'Expira em ' + assoc.expire_days + ' dias';
          }
          $('#assoc-list').append(`
        <div class="border rounded p-3 mb-3">
          <div><b>Produto:</b> ${assoc.product_title}</div>
          <div><b>Curso:</b> ${assoc.classroom_title}</div>
          <div><b>Acesso:</b> ${acessoInfo}</div>
          <div class="mt-2"><button class="btn btn-sm btn-danger" data-assoc="${ix}"><i class="las la-trash"></i> Remover</button></div>
        </div>`);
        });
        $('.assoc-list-wrp').show();
      }
    }

    // Remove uma associação
    $('#assoc-list').on('click', '.btn-danger', function (ev) {
      ev.preventDefault();
      const assocIndex = $(this).data('assoc');
      if (assocList[assocIndex]) {
        assocList.splice(assocIndex, 1);
        $('#assoc_list').val(JSON.stringify(assocList));
        populateList();
        Toast.fire({
          type: 'success',
          title: 'Associação removida com sucesso!',
        });
      }
    });
  }
})();
